// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","container":"container-2_MpV","thumbContainer":"thumbContainer-2h1S-","thumb":"thumb-245-D","icon":"icon-24dKj","title":"title-aFtkA","leaf":"leaf-30-Au","percentile":"percentile-3YqN8","distance":"distance-6-zfY","duration":"duration-2znbR","avg_pace":"avg_pace-1ylZc","energy_burned":"energy_burned-3Qp8o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/feed/_highlight.css
// module id = 1212
// module chunks = 1